import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import { shallowEqual } from 'react-redux';
import { DEFAULT_FONT_FAMILY } from '../../../../constants/constants';
import { useAppSelector } from '../../../../redux/store';
import { PLAYER_BUBBLE_TEXT_COLOR_NUM } from '../../../../styles/colors';
import { getPlayerBubbleProperties } from '../../../../utils/playerBubbleUtils';
import { PlayerBubbleDisplay } from './playerBubbleDisplay';
const OUTER_PADDING_PX = 3; // padding around the set of all player bubbles
const INNER_PADDING_PX = 1; // padding between bubbles
export const PlayerBubblesContainer = ({ seatIndex }) => {
    // TODO: Improve the efficiency of this selector:
    const playerBubbles = useAppSelector((state) => state.playerBubbles.bubbles[seatIndex]);
    const bounds = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex], shallowEqual);
    const bubbleWidth = bounds.w - OUTER_PADDING_PX * 2;
    const textStyle = useMemo(() => new PIXI.TextStyle({
        fill: PLAYER_BUBBLE_TEXT_COLOR_NUM,
        leading: -2,
        fontFamily: DEFAULT_FONT_FAMILY,
        fontSize: isMobile ? 14 : 16,
        wordWrap: true,
        wordWrapWidth: bubbleWidth - OUTER_PADDING_PX * 2,
        align: 'center'
    }), [bubbleWidth]);
    if (!playerBubbles) {
        return null;
    }
    let y = OUTER_PADDING_PX;
    const containerX = bounds.x - Math.round(bounds.w / 2);
    const containerY = bounds.y - Math.round(bounds.h / 2);
    return (_jsx(Container, { x: containerX, y: containerY, children: playerBubbles.map((playerBubble) => {
            const currY = y;
            const playerBubbleAllProperties = getPlayerBubbleProperties(playerBubble, textStyle, bubbleWidth);
            y += playerBubbleAllProperties.dimensions.h + INNER_PADDING_PX;
            return (_jsx(PlayerBubbleDisplay, { playerBubble: playerBubble, playerBubbleAllProperties: playerBubbleAllProperties, x: OUTER_PADDING_PX, y: currY, w: bounds.w - 2 * OUTER_PADDING_PX, h: playerBubbleAllProperties.dimensions.h, textStyle: textStyle }, playerBubble.id));
        }) }));
};
